// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__Zk3mf","gfeWrapper":"CalendarEvent_gfeWrapper__4W21O"};